/* global __SERVER__ */

import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { func, object, string, bool } from 'prop-types';

import { isMobile } from '@snapask/common-components/dist/utils/detectMobileType';

import MainLayout from '@blueberry/layouts/MainLayout';

import { fetchPostFlow } from '@blueberry/sagas/post';
import { actions, getPost, getStatus } from '@blueberry/redux/post';
import { getIsInapp } from '@blueberry/redux/location';
import { getUserID } from '@blueberry/redux/profile';
import { generatePostURL } from '@blueberry/redux/navigation';

import SEOHead from '@blueberry/components/SEOHead';
import NotFound from '@blueberry/components/NotFound';

import PostContent from './components/PostContent';

import { VIDEO } from '@blueberry/constants/postType';
import { WEB, MWEB } from '@blueberry/constants/platform';
import { ERROR } from '@blueberry/constants/loadingState';

import { haveObjectProperties } from '@blueberry/utils/utility';

const mapStateToProps = state => ({
  post: getPost(state),
  isInapp: getIsInapp(state),
  status: getStatus(state),
  hasLogin: !!getUserID(state),
  getPostURL: generatePostURL(state),
});

class Post extends Component {
  static prefetch = ({ id }) => [fetchPostFlow, { payload: { id } }];

  static propTypes = {
    fetchQuizHistory: func.isRequired,
    getPostURL: func.isRequired,
    hasLogin: bool.isRequired,
    isInapp: bool.isRequired,
    post: object.isRequired,
    postEvent: func.isRequired,
    resetPost: func.isRequired,
    status: string.isRequired,
  };
  static contextTypes = {
    region: string,
  };

  componentDidMount() {
    this.triggerAPI(this.props.post);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.post !== this.props.post) {
      this.triggerAPI(nextProps.post);
    }
  }

  componentWillUnmount() {
    this.props.resetPost();
  }

  getTrackData() {
    return {
      webPlatform: isMobile() ? MWEB : WEB,
      // only have value on user come from search site (like google, bing)
      referrer: document.referrer,
      url: window.location.href,
    };
  }

  getImageUrl = post => {
    if (post.type === VIDEO) {
      return post.mediaImageUrl;
    }

    return post.mediaUrl;
  };

  triggerAPI = post => {
    const { postEvent, isInapp, fetchQuizHistory, hasLogin } = this.props;

    const shouldFetchQuiz =
      !isInapp && hasLogin && post.concepts && post.concepts.length > 0;
    if (shouldFetchQuiz) {
      fetchQuizHistory();
    }

    const urlParams = new URLSearchParams(window.location.search);
    const visitCount = urlParams.get('visit_count');

    if (visitCount === 'false') return;
    const trackData = this.getTrackData();
    postEvent(trackData);
  };

  render() {
    const { post, status, getPostURL } = this.props;
    const {
      metaTitle,
      urlTitle,
      id,
      metaDescription,
      publishDate,
      category,
      curriculumName,
      subjectName,
      topicName,
      subtopicName,
    } = post;
    const postURL = getPostURL({ title: urlTitle, id });
    const pathWithoutLocale = postURL
      .split('/')
      .splice(2)
      .join('/');

    const seoComponent = (
      <SEOHead
        path={pathWithoutLocale}
        title={metaTitle}
        description={metaDescription}
        contentType="article"
        published={publishDate}
        updated={publishDate}
        seoImage={this.getImageUrl(post)}
        category={category}
        tag={`${curriculumName} ${subjectName} ${topicName} ${subtopicName}`}
      />
    );

    if (__SERVER__) {
      return seoComponent;
    }

    const hasPost = haveObjectProperties(post);

    return (
      <MainLayout showFooter showSubjectBackground={false}>
        {seoComponent}
        {hasPost && <PostContent post={post} />}
        {!hasPost && status === ERROR && <NotFound />}
      </MainLayout>
    );
  }
}

export default compose(
  connect(mapStateToProps, {
    postEvent: actions.postEvent,
    resetPost: actions.resetPost,
    fetchQuizHistory: actions.fetchQuizHistory,
  })
)(Post);



// WEBPACK FOOTER //
// ./app/containers/Post/Post.jsx